var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.wdays,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5072cb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/WeekDay.vue
// module id = null
// module chunks = 